// extracted by mini-css-extract-plugin
export default {"content":"EQ","wrapper":"FQ","gif":"GQ","textContent":"HQ","gifContainer":"IQ","proteinGif":"JQ","counter_img":"KQ","usage-container":"LQ","usage-list":"MQ","checklist":"NQ","counter_title":"OQ","counter_wrapper":"PQ","active":"QQ","usage-counter":"RQ","line":"SQ"};
    if(module.hot) {
      // 1715632478452
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  